import { get } from 'lodash'

import { isRequestComplete, isRequestPending } from '@/store/selectors'

import {
  CREATE_CHANNEL_CONNECTION,
  DELETE_CHANNEL_CONNECTION,
  FETCH_CHANNEL_CONNECTIONS,
  UPDATE_CHANNEL_CONNECTION
} from './actionTypes'
import { ChannelConnection } from './interfaces'

export const getChannelConnectionsFetchData = (state: any) => {
  return {
    channelConnections: get(state, 'organizationChannelConnectionsPage.channelConnections', []),
    isLoading: isRequestPending(state, [FETCH_CHANNEL_CONNECTIONS]),
    isCompleted: isRequestComplete(state, [FETCH_CHANNEL_CONNECTIONS]),
    isDeleting: isRequestPending(state, [DELETE_CHANNEL_CONNECTION]),
    isSaving: isRequestPending(state, [CREATE_CHANNEL_CONNECTION, UPDATE_CHANNEL_CONNECTION])
  }
}

export const getCurrentChannelConnection = (state: any) => {
  return (
    (state.organizationChannelConnectionsPage &&
      state.organizationChannelConnectionsPage.channelConnections.find(
        (channelConnection: ChannelConnection) => channelConnection.currentChannelConnection === true
      )) ||
    {}
  )
}
